export default __webpack_public_path__ + "static/media/peopleperhour.d8367164.webp";